import { render } from "./SuperAdminProfile.vue?vue&type=template&id=74af20fb&scoped=true"
import script from "./SuperAdminProfile.vue?vue&type=script&lang=js"
export * from "./SuperAdminProfile.vue?vue&type=script&lang=js"

import "./SuperAdminProfile.vue?vue&type=style&index=0&id=74af20fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74af20fb"]])

export default __exports__